<script setup lang="ts">
// PROPS
import { computed } from 'vue';

const props = defineProps<{
  type: 'info' | 'warning' | 'danger' | 'success';
  title: string;
  description: string;
}>();

const iconName = computed(() => {
  switch (props.type) {
    case 'info':
      return 'info';
    case 'danger':
      return 'warning';
    case 'warning':
      return 'priority_high';
    case 'success':
      return 'check_circle';
    default:
      return 'info';
  }
});

const iconColor = computed(() => {
  switch (props.type) {
    case 'info':
      return 'blue-9'; // Blue for info
    case 'danger':
      return 'red-9'; // Red for danger
    case 'warning':
      return 'orange-8'; // Yellow for warning
    case 'success':
      return 'green-8'; // Green for success
    default:
      return 'blue-9';
  }
});

// COMPUTED CLASS FOR TYPE
const typeClass = computed(() => `${props.type}`);
</script>

<template>
  <div :class="['info-box', `box-bg-${typeClass}`]">
    <div class="icon">
      <q-icon size="xs" :class="['info-icon', typeClass]" :name="iconName" />
    </div>
    <div class="content">
      <h3>{{ props.title }}</h3>
      <p>{{ props.description }}</p>
    </div>
  </div>
</template>

<style lang="scss">
.info-box {
  display: flex;

  padding: 16px;
  border-radius: 8px;
  align-items: flex-start;
  margin-bottom: 20px;
}

.icon {
  margin-right: 12px;
  display: flex;
}

.info-icon {
  font-size: 14px;
}

// Define color classes based on the `type` prop
// TODO: Definir couleur
.info {
  color: $primary;
}
.box-bg-info {
  background-color: #eef5ff;
}

.danger {
  color: #dc3545; // Red for danger and error
}
.box-bg-danger {
  background-color: #e8b5ba;
}

.warning {
  color: #ffc107; // Yellow for warning
}
.box-bg-warning {
  background-color: #ffebb9;
}

.success {
  color: #28a745; // Green for success
}
.box-bg-success {
  background-color: #84a68b;
}

.content h3 {
  margin: 0;
  font-weight: bold;
  color: #1a1a1a;
  font-size: 14px !important;
}

.content p {
  margin: 4px 0 0;
  color: #333;
  font-size: 12px;
}
</style>
